import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-avatar";
//#region src/components/primitives/avatar.tsx
var o = ["className"], s = ["className"], c = ["className"], l = r.forwardRef((r, s) => {
	let { className: c } = r, l = t(r, o);
	return /* @__PURE__ */ i(a.Root, n({
		ref: s,
		"data-slot": "avatar",
		className: e("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", c)
	}, l));
});
l.displayName = a.Root.displayName;
var u = r.forwardRef((r, o) => {
	let { className: c } = r, l = t(r, s);
	return /* @__PURE__ */ i(a.Image, n({
		ref: o,
		"data-slot": "avatar-image",
		className: e("aspect-square h-full w-full", c)
	}, l));
});
u.displayName = a.Image.displayName;
var d = r.forwardRef((r, o) => {
	let { className: s } = r, l = t(r, c);
	return /* @__PURE__ */ i(a.Fallback, n({
		ref: o,
		"data-slot": "avatar-fallback",
		className: e("flex h-full w-full items-center justify-center rounded-full bg-muted", s)
	}, l));
});
d.displayName = a.Fallback.displayName;
//#endregion
export { l as Avatar, d as AvatarFallback, u as AvatarImage };

//# sourceMappingURL=avatar.js.map